var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 37.5,
    stroke: "#12304F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 1.5V31",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40H55.5",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45.5L63.5 66",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1337 33.8663L13.8917 50.1083C13.6354 50.3646 13.4502 50.6853 13.4105 51.0456C13.3335 51.7444 13.3242 52.9864 14 54C14.5803 54.8704 15.6656 55.4041 16.4745 55.6988C17.1028 55.9277 17.784 55.716 18.2569 55.2431L30.1832 43.3168C30.9251 42.5749 32.1143 42.5324 32.9073 43.2196L37.5927 47.2804C38.3857 47.9676 39.5748 47.9252 40.3168 47.1832L55.6665 31.8335C56.4153 31.0847 57.618 31.0493 58.4095 31.7529L58.761 32.0653C59.9438 33.1168 61.8214 32.4429 62.0657 30.8793L63.5723 21.237C63.7829 19.8895 62.6127 18.7312 61.2675 18.9554L52.4878 20.4187C50.9649 20.6725 50.3118 22.4992 51.3284 23.661C51.9939 24.4217 51.9763 25.5625 51.2876 26.3022L40.3645 38.0344C39.6112 38.8435 38.3443 38.888 37.5361 38.1337L32.9126 33.8184C32.1247 33.083 30.8958 33.1042 30.1337 33.8663Z",
    fill: "#77D3B4",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0768 25.6192V9.4408C34.0768 8.17832 32.9237 7.24004 31.6994 7.54822C29.6279 8.06967 26.6405 8.93209 24.5768 10C20.0248 12.3556 17.7412 14.4681 14.5768 18.5C10.7456 23.3816 8.73692 26.8297 8.07684 33C7.74715 36.0819 8.54356 40.1779 9.22711 42.942C9.58054 44.3712 11.3133 44.8269 12.3814 43.8136L28.9568 28.0882C29.3529 27.7125 29.8852 27.515 30.4305 27.5415L31.9797 27.6168C33.1211 27.6723 34.0768 26.7619 34.0768 25.6192Z",
    fill: "#6AD3B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRevenue);
export default __webpack_public_path__ + "static/media/icon-revenue.4bf49405875dff883e813e4c4c30b2de.svg";
export { ForwardRef as ReactComponent };